import { COOKIE_MODAL_BASE_CLASS_NAME } from "../constants";

/**
 * @name checkIsModalVisible
 * @description - Function to determine if modal is visible.
 * @returns {boolean}
 */
export const checkIsModalVisible = () => !!document.querySelector(`.${COOKIE_MODAL_BASE_CLASS_NAME}`);